import { createContext } from "react";
import { User, Session } from "@supabase/supabase-js";

export type AuthContextType = {
  user: User | null;
  session: Session | null;
  userRole: string | null;
  isAdmin: boolean;
  loading: boolean; 
  isLoading: boolean; // Alias for loading
  ready: boolean; // Added ready flag to track when auth is fully established
  signIn?: (email: string, password: string) => Promise<{ error: Error | null }>;
  signUp?: (email: string, password: string, role?: string, companyName?: string, firstName?: string, lastName?: string, priceId?: string) => Promise<{ error: Error | null }>;
  signOut?: () => Promise<{ error: Error | null }>; // Updated return type
  organizationId?: string | null;
  subscriptionStatus?: string | null;
  hasValidSubscription?: boolean;
  subscriptionLoading?: boolean;
  refreshUser?: () => Promise<void>;
};

// Initialize with default values to prevent "undefined" errors
export const AuthContext = createContext<AuthContextType>({
  user: null,
  session: null,
  userRole: null,
  isAdmin: false,
  loading: true,
  isLoading: true,
  ready: false, // Default is not ready
  organizationId: null,
  subscriptionStatus: null,
  hasValidSubscription: false,
  subscriptionLoading: false,
  refreshUser: async () => {},
});
